import { Link } from "react-router-dom";
import { blogPosts } from "@/data/blogPosts";

const QUICK_AIRPORTS = ["ATL", "ORD", "LAX", "DFW", "JFK", "LGA", "DEN", "MCO", "EWR", "BOS"];

interface QuickAirportRowProps {
  currentCode: string;
}

/**
 * Compact "keep exploring" row placed high on the airport page.
 * Additive: does not replace <PopularAirports /> at the bottom.
 */
export const QuickAirportRow = ({ currentCode }: QuickAirportRowProps) => {
  const codes = QUICK_AIRPORTS.filter((c) => c !== currentCode.toUpperCase()).slice(0, 8);
  const featured =
    blogPosts?.find((p) => p.slug === "airport-arrival-time-calculator") ?? blogPosts?.[0];

  return (
    <nav aria-label="Other airports" className="space-y-3">
      <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-none">
        {codes.map((code) => (
          <Link
            key={code}
            to={`/airports/${code.toLowerCase()}`}
            className="shrink-0 min-h-[44px] inline-flex items-center px-4 rounded-xl border border-border bg-card shadow-sm text-base font-semibold text-foreground hover:border-primary/40 hover:bg-primary/5 active:scale-95 transition-all"
          >
            {code}
          </Link>
        ))}
      </div>
      {featured && (
        <p className="text-base text-muted-foreground">
          Not sure when to leave?{" "}
          <Link to={`/blog/${featured.slug}`} className="text-primary hover:underline font-medium">
            {featured.title}
          </Link>
        </p>
      )}
    </nav>
  );
};
